export default "__VITE_ASSET__CEqM4WK4__"